import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { TipoDestinoEnum } from "core/features/documentos/enums";

export interface MensagemItem {
  id: string;
  conteudo: string;
  conteudoPlain: string;
  createdAt: string;
  lida?: boolean;
  lidasPorOutrosUsuarios?: boolean;
  respondida?: boolean;
  novaMensagem: boolean;
  numeroNovasMensagens?: number;
  destino: string;
  assunto: string;
  imagemUrl?: string | null;
  autor?: string;
  unidade?: string;
  novasRespostas?: boolean;
  tenant?: {
    id: string;
    nome: string;
  };
}

export interface MensagemAnexo {
  arquivoId: string;
  referencia: string;
  nome: string;
  mimetype?: string;
}

export interface MensagemHistorico extends MensagemItem {
  numRespostas: number;
  imagemUrl?: string;
  autor: string;
  anexos: MensagemAnexo[];
}

export interface MensagemDetalhe extends Omit<MensagemHistorico, "lida"> {
  numDestinos?: number;
  numDestinosLidos?: number;
  origem: MensagemOrigem;
  unidade?: string;
}
export interface AssuntoMensagemItem {
  id: string;
  nome: string;
  icone: AssuntoMensagemIcone;
}

export enum AssuntoMensagemIcone {
  Caneta = "caneta",
  Gota = "gota",
  Raio = "raio",
  Som = "som",
  Vassoura = "vassoura",
}

export interface MensagemTableDataRow extends Partial<MensagemItem> {
  isDateRow: boolean;
}

export interface ListagemMensagemResponse extends PaginateResult<MensagemItem> {
  naoLidas: number;
}

export enum AssuntoMensagem {
  Outros = "A624121D-2A0D-46E6-B5A9-B0D8E44BECDA",
}

export interface Destino {
  tipoDestinoId: string;
  destinoId: string;
  label: string;
}

export interface MensagemForm {
  tenantId?: string;
  enviarEmail: boolean;
  conteudo: string;
  conteudoPlain?: string;
  assuntoId: string;
  anexos?: File[];
  assuntoCustomizado?: string;
  tipoDestinoId: string;
  destinoId?: string;
  destinos: Destino[];
  mensagemRespostaId?: string;
}

export interface RespostaMensagemForm {
  anexos?: File[];
  conteudo: string;
  conteudoPlain?: string;
}

export enum MensagemOrigem {
  Recebida = "recebida",
  Enviada = "enviada",
  Excluida = "excluida",
  Arquivada = "arquivada",
}

export interface MensagemFiltro extends PaginateQuery {
  origem: MensagemOrigem;
  mensagensRespondidas?: boolean;
  tipoDestinoId?: TipoDestinoEnum;
  dataInicio?: string;
  dataFim?: string;
  orderDirection?: "ASC" | "DESC";
  orderBy?: string;
  tenantsIds?: string[];
}

export interface MensagemRecebidaUnidadeFiltro extends PaginateQuery {
  unidadeId: string;
}

export interface MensagemLeituraResponse {
  createdAt?: string;
  proprietario: string;
  unidade: {
    numero: string;
    blocoQuadra?: string;
  };
  imagemUrl?: string | null;
}
